import TextReportGenerator from "../TextReportGenerator";
import ReportData from "../../ReportData";
import { saveClassByClassNameDecorator } from "../../../../shared/utils/classNameToConstructor";
import { DisplayedField } from "../../DisplayedField";

const DEFAULT_VERSION = "1";

const TITLE: string = "ClearVoyage Statement of Facts Report";

const FIELDS: DisplayedField[] = [
  { fieldType: "IMONumber", required: true },
  { fieldType: "ReportDate", required: true },
  { fieldType: "Remarks", required: false },
  { fieldType: "Position", required: true },
  { fieldType: "StatementOfFactsActivities", required: true },
  { fieldType: "CurrentPort", required: true },
];

@saveClassByClassNameDecorator()
class ClearVoyageStatementOfFactsReportGenerator extends TextReportGenerator {
  public constructor() {
    super(TITLE, FIELDS, DEFAULT_VERSION);
  }

  getReportText(_data: ReportData, _version: string | undefined): string {
    return "";
  }
}

export default ClearVoyageStatementOfFactsReportGenerator;
